export default __webpack_public_path__ + "static/media/opensea.5bdee2f6.svg";